import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { selectPrefix, selectUserType } from '../../Redux/profile';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../../Redux/security';

import axios from 'axios';
import { FormatNumber2 } from '../tools';
import { CollectionFromToDate } from '../collectionFromToDate';
import {
  selectCustomerMasterHelpModStatus,
  setCustomerMasterHelpModStatus,
  setModCustomerMasterModifyStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../../Redux/modal';
import {
  selectBookingCustomerDetails,
  setBookingAttachImage,
  setHistoryOrderDetails,
  setModifyingBookingId,
  setSelctedBookingUpperitemDetails,
  setSelectedBooingLowerItemDetails,
} from '../../Redux/booking';
import { CollectionFromToDateMobile } from '../collectionFromToDateMobile';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import PrintVoucherSummary from '../../../summary/printVoucherSummary';
import CustomerMasterhelp from '../../../help/customermasterHelp';
import { CallAPIPromise } from '../../func/func';

const width = window.innerWidth / 100;

const VoucherSummary = () => {
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);

  const dispatch = useDispatch();
  const [firstDate, setFirstDate] = useState(moment().format('YYYY-MM-DD'));
  const [SecondDate, setSecondDate] = useState(moment().format('YYYY-MM-DD'));
  const [list, setList] = useState([]);
  const [bookingCustomerDetails, setBookingCustomerDetails] = useState({
    code: '',
    customer_name: '',
    mobile: '',
    mobile_2: '',
    mobile_3: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pin_code: '',
    credit_limit: 100000,
    company_name: '',
    company_phone: '',
    company_email: '',
    company_address: '',
    company_city: '',
    company_state: '',
    company_country: '',
    company_pincode: '',
    regd_no1: '',
    regd_no2: '',
    regd_no3: '',
    status: 'Good',
    remarks: '',
  });

  const customerMasterModalStatus = useSelector(
    selectCustomerMasterHelpModStatus
  );

  const customerDetails = (params) => {
    dispatch(setBookingAttachImage(''));
    dispatch(setSelectedBooingLowerItemDetails(''));
    dispatch(setSelctedBookingUpperitemDetails(''));
    dispatch(setModifyingBookingId(''));
    setBookingCustomerDetails(params.row);
    dispatch(setCustomerMasterHelpModStatus(false));
    dispatch(setHistoryOrderDetails(''));
  };

  const columns = [
    {
      field: 'VOUCHER_NO',
      accessor: 'VOUCHER_NO',
      type: 'number',
      width: 76,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Voucher No.'}
        </div>
      ),
    },
    {
      field: 'DATE',
      accessor: 'DATE',
      type: 'string',
      width: 124,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Date'}
        </div>
      ),
    },
    {
      field: 'CUSTOMER_NAME',
      accessor: 'CUSTOMER_NAME',
      type: 'string',
      width: 180,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Customer Name'}
        </div>
      ),
    },

    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      type: 'string',
      width: 140,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mobile'}
        </div>
      ),
    },

    {
      field: 'AMOUNT_DESC',
      accessor: 'AMOUNT_DESC',
      type: 'number',
      flex: 1,
      minWidth: 260,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Description'}
        </div>
      ),
    },

    {
      field: 'DEBIT',
      accessor: 'DEBIT',
      type: 'string',
      width: 120,
      headerAlign: 'center',
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Debit'}
        </div>
      ),
    },
    {
      field: 'CREDIT',
      accessor: 'CREDIT',
      type: 'string',
      width: 120,
      headerAlign: 'center',
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Credit'}
        </div>
      ),
    },

    {
      field: 'PAY_MODE',
      accessor: 'PAY_MODE',
      type: 'string',
      width: 130,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Pay Mode'}
        </div>
      ),
    },
    {
      field: 'CARD_NO',
      accessor: 'CARD_NO',
      type: 'string',
      width: 130,

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Card No.'}
        </div>
      ),
    },
    {
      field: 'EPAYMENT_BANK',
      accessor: 'EPAYMENT_BANK',
      type: 'string',
      width: 170,

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'ePayment Bank'}
        </div>
      ),
    },
  ];

  const columnsTab = [
    {
      field: 'VOUCHER_NO',
      accessor: 'VOUCHER_NO',
      type: 'number',
      width: width * 10,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'V No.'}
        </div>
      ),
    },
    {
      field: 'DATE',
      accessor: 'DATE',
      type: 'string',
      width: width * 12,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Date'}
        </div>
      ),
    },
    {
      field: 'CUSTOMER_NAME',
      accessor: 'CUSTOMER_NAME',
      type: 'string',
      width: width * 20,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Customer Name'}
        </div>
      ),
    },

    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      type: 'string',
      width: width * 20,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mobile'}
        </div>
      ),
    },

    {
      field: 'DEBIT',
      accessor: 'DEBIT',
      type: 'string',
      width: width * 10,
      headerAlign: 'center',
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Debit'}
        </div>
      ),
    },
    {
      field: 'CREDIT',
      accessor: 'CREDIT',
      type: 'string',
      width: width * 10,
      headerAlign: 'center',
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Credit'}
        </div>
      ),
    },
  ];

  const columnsMobile = [
    {
      field: 'DATE',
      type: 'string',
      width: width * 21,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('YYYY-MM-DD');
        } else {
          return '';
        }
      },

      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'Date'}</div>,
    },
    {
      field: 'CUSTOMER_NAME',
      type: 'string',
      width: width * 30,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Customer Name'}
        </div>
      ),
    },

    {
      field: 'CREDIT',
      type: 'string',
      width: width * 20,
      headerAlign: 'center',
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Credit'}
        </div>
      ),
    },

    {
      field: 'PAY_MODE',
      type: 'string',
      width: width * 20,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Pay Mode'}</div>
      ),
    },
  ];
  const loadVocherAPI = (invNo) => {
    const data = {
      table_prefix: prefix,
      FDATE: firstDate,
      TDATE: SecondDate,
      MOBILE: bookingCustomerDetails.mobile,
    };

    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(`/api/vouchers/voucherSummary`, data)
      .then(async function (response) {
        if (!response.data.error) {
          setList(response.data.response);
        }
      })
      .catch(function (error) {
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(error);
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const printRef = useRef();
  const navigate = useNavigate();
  const thermalPrintRef = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState('print');
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize <= 800;
  const gridColumns =
    windowSize <= 500
      ? columnsMobile
      : windowSize <= 800
      ? columnsTab
      : columns;
  const debitTotal = list.reduce(
    (total, row) => total + (Number(row.DEBIT) || 0),
    0
  );
  const creditTotal = list.reduce(
    (total, row) => total + (Number(row.CREDIT) || 0),
    0
  );
  const balance = creditTotal - debitTotal;
  const tableHeight = Math.min(460, Math.max(180, 112 + list.length * 42));

  const handlePrint = useReactToPrint({
    content: () =>
      selectedPrintOption === 'print'
        ? printRef.current
        : thermalPrintRef.current,
    pageStyle: `
      @page { size: A4 landscape; margin: 10mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
    onAfterPrint: () => {
      navigate('/voucher_summary');
      setSelectedPrintOption('print');
    },
  });

  const summaryCards = [
    {
      label: 'Total Vouchers',
      value: list.length,
      detail:
        list.length === 1 ? '1 voucher found' : `${list.length} vouchers found`,
      icon: 'bi-receipt',
      tone: 'text-[#f08a4b]',
      iconBg: 'bg-[#fff2e8]',
    },
    {
      label: 'Total Debit',
      value: `₹${FormatNumber2(debitTotal)}`,
      detail: 'Debit transactions',
      icon: 'bi-arrow-up-right-circle',
      tone: 'text-[#7866e9]',
      iconBg: 'bg-[#f0edff]',
    },
    {
      label: 'Total Credit',
      value: `₹${FormatNumber2(creditTotal)}`,
      detail: 'Credit transactions',
      icon: 'bi-arrow-down-left-circle',
      tone: 'text-[#8dbb28]',
      iconBg: 'bg-[#f1f8df]',
    },
    {
      label: 'Net Balance',
      value: `₹${FormatNumber2(Math.abs(balance))}`,
      detail: balance < 0 ? 'Debit balance' : 'Credit balance',
      icon: 'bi-wallet2',
      tone: 'text-[#12a9b4]',
      iconBg: 'bg-[#e6f9fa]',
    },
  ];

  return (
    <div
      className={`flex h-full min-h-0 min-w-0 w-full flex-col overflow-x-hidden bg-[#f3f6fb] p-3 ${
        isMobile ? 'overflow-y-auto' : 'overflow-y-hidden'
      }`}
    >
      <div className="mb-3 grid shrink-0 grid-cols-2 gap-3 xl:grid-cols-4">
        {summaryCards.map((card) => (
          <div
            key={card.label}
            className="flex min-w-0 items-center rounded-md border border-[#e3e8f0] bg-white px-4 py-3 shadow-[0_2px_8px_rgba(31,45,61,0.04)]"
          >
            <div
              className={`mr-3 flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${card.iconBg} ${card.tone}`}
            >
              <i className={`bi ${card.icon}`}></i>
            </div>
            <div className="min-w-0">
              <div className="truncate text-xs font-medium text-[#687386]">
                {card.label}
              </div>
              <div className={`truncate text-lg font-bold ${card.tone}`}>
                {card.value}
              </div>
              <div className="truncate text-[11px] text-[#8a94a6]">
                {card.detail}
              </div>
            </div>
          </div>
        ))}
      </div>

      {isMobile ? (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDateMobile
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-[30px] items-center justify-center gap-2 rounded-md border border-[#7866e9] px-4 text-sm font-semibold text-[#7866e9] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              setBookingCustomerDetails({ customer_name: '', mobile: '' });
            }}
            bookingCustomerDetails={bookingCustomerDetails}
          />
        </div>
      ) : (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDate
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-12 items-center justify-center gap-2 rounded-md border border-[#7866e9] px-5 text-sm font-semibold text-[#7866e9] transition hover:bg-[#f4f1ff] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              setBookingCustomerDetails({ customer_name: '', mobile: '' });
            }}
            bookingCustomerDetails={bookingCustomerDetails}
            reportLayout
          />
        </div>
      )}

      <div
        className={`mt-3 flex min-h-0 min-w-0 flex-col max-sm:mt-2 ${
          isMobile ? 'shrink-0' : 'flex-1'
        }`}
      >
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <div
            className={`min-h-[180px] min-w-0 overflow-hidden ${
              isMobile ? 'shrink-0' : 'flex-1'
            }`}
            style={isMobile ? { height: tableHeight } : undefined}
          >
            <DataGrid
              sx={{
                height: '100%',
                width: '100%',
                minWidth: 0,
                borderRadius: '6px',
                backgroundColor: 'white',
                border: '1px solid #e3e8f0',
                fontSize: 14,
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#e9edf7',
                  color: '#30384d',
                  borderBottom: '2px solid #7866e9',
                },
                '& .MuiDataGrid-columnHeader': {
                  backgroundColor: '#e9edf7',
                  borderRight: '1px solid #dce2ec',
                },
                '& .MuiDataGrid-columnHeader:last-of-type': {
                  borderRight: '0',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 700,
                  fontSize: '12px',
                  letterSpacing: '0.025em',
                  overflow: 'visible',
                  textOverflow: 'clip',
                },
                '& .super-app-theme--header': {
                  backgroundColor: '#e9edf7',
                },
                '& .MuiDataGrid-cell': {
                  borderRight: '1px solid #e8ecf3',
                  borderBottom: '1px solid #edf1f5',
                  color: '#465266',
                },
                '& .MuiDataGrid-cell:last-of-type': {
                  borderRight: '0',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#f2f0ff',
                },
                '& .MuiDataGrid-row:nth-of-type(even)': {
                  backgroundColor: '#f8faff',
                },
                '& .MuiDataGrid-footerContainer': {
                  borderTop: '1px solid #e3e8f0',
                  color: '#687386',
                },
                '& .MuiDataGrid-virtualScroller': {
                  overflowX: 'auto',
                  overflowY: 'auto',
                  overscrollBehavior: 'contain',
                },
              }}
              rowHeight={42}
              headerHeight={46}
              columns={gridColumns}
              rows={list}
              pagination
              scrollbarSize={8}
              getRowId={(e) => e.VOUCHER_NO}
              rowsPerPageOptions={[100]}
              experimentalFeatures={{ newEditingApi: true }}
              showCellRightBorder={true}
              showColumnRightBorder={true}
              disableColumnSelector
              disableColumnReorder
              disableColumnMenu={true}
              components={{
                NoRowsOverlay: () => (
                  <div className="flex h-full w-full flex-col items-center justify-center text-ggray">
                    <i className="bi bi-receipt mb-2 text-2xl opacity-60"></i>
                    <span className="font-medium">No vouchers found</span>
                    <span className="mt-1 text-xs">
                      Change the date range or customer and apply the filter.
                    </span>
                  </div>
                ),
              }}
            />
          </div>

          <div className="mt-2 min-w-0 shrink-0 overflow-x-auto rounded-md border border-[#dfe5ef] bg-white">
            <div
              className="grid min-h-[48px] min-w-[1450px] items-center text-sm"
              style={{
                gridTemplateColumns:
                  '76px 124px 180px 140px minmax(260px, 1fr) 120px 120px 130px 130px 170px',
              }}
            >
              <div className="col-span-5 flex h-full items-center justify-end border-r border-[#e8ecf3] px-3 text-xs font-bold text-[#4e596c]">
                Column Totals
              </div>
              <div className="flex h-full items-center justify-end border-r border-[#e8ecf3] px-3 font-bold text-[#6654dc]">
                ₹{FormatNumber2(debitTotal)}
              </div>
              <div className="flex h-full items-center justify-end border-r border-[#e8ecf3] px-3 font-bold text-[#7aa51e]">
                ₹{FormatNumber2(creditTotal)}
              </div>
              <div className="col-span-3 h-full"></div>
            </div>
          </div>
        </div>
      </div>

      <CustomerMasterhelp
        onRowClick={(params) => {
          if (customerMasterModalStatus) {
            customerDetails(params);
          }
          dispatch(setModCustomerMasterModifyStatus(false));
        }}
      />

      <div className="hidden">
        {selectedPrintOption === 'print' && windowSize ? (
          <div
            ref={printRef}
            style={{ display: 'block', visibility: 'hidden' }}
          >
            <PrintVoucherSummary
              data={list}
              firstDate={firstDate}
              SecondDate={SecondDate}
              bookingCustomerDetails={bookingCustomerDetails}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default VoucherSummary;
